
import { StringNullableChain } from "lodash"
import { Component, Vue, Watch, Prop, ProvideReactive } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import VuePerfectScrollbar from "vue-perfect-scrollbar"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar
	}
})
export default class SelectModal extends Vue {
	@Prop({ default: null })
	value!: { title: string }[] | null

	@Prop({ default: "title" })
	label!: string

	@Prop({ default: "" })
	title!: string

	get filteredItems (): any[] {
		if (!this.value) return []
		if (this.filter === "") return this.value

		const lower = this.filter.toLowerCase()
		return this.value.filter((item: any) => item && !!item[this.label] && item[this.label].toLowerCase().includes(lower))
	}

	get open (): boolean {
		return this.value !== null
	}

	set open (value: boolean) {
		if (!value) {
			this.$emit("input", null)
		}
	}

	private filter: string = ""

	itemClicked (item: any) {
		this.$emit("input", null)
		this.$emit("itemClicked", item)
	}
}
